export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8098.b364a65d.jpg";